export default {
    notify_00001: 'Notiz',
    notify_00002: 'Alle Benachrichtigungen',
    notify_00003: 'Jahr',
    notify_00004: 'Mond',
}